import { format } from 'date-fns';
import { createIcsString } from 'server/shared/helpers/createIcsString';
import { getDepartmentDisplayName } from 'server/shared/helpers/getDepartmentDisplayName';
import { Job } from 'server/shared/models/job';
import { PartialAcceptTime } from 'server/shared/models/partialAcceptTime';
import { Shift } from 'server/shared/models/shift';

export function downloadJobICS(job: Job) {
  if (!job.yourself) return;
  let shifts: Shift[] | PartialAcceptTime[] = job.shifts;
  if (job.yourself.partialTimes) {
    shifts = job.yourself.partialTimes;
  } else if (job.yourself.shifts) {
    shifts = job.yourself.shifts;
  }
  const link =
    window.location.protocol +
    '//' +
    window.location.host +
    '/jobs?state=closed&range=custom,' +
    job.date +
    ',' +
    job.date;

  const icsString = createIcsString(job, shifts, link);
  const blob = new Blob([icsString], { type: 'text/calendar' });
  let url = URL.createObjectURL(blob);
  let a = document.createElement('a');
  a.href = url;

  a.download =
    getDepartmentDisplayName(job.department.name, job.organisation).replace(
      /\s/g,
      '',
    ) +
    '_' +
    format(new Date(job.date), 'dd-MM-yyyy') +
    '.ics';
  a.dispatchEvent(
    new MouseEvent(`click`, {
      bubbles: false,
      cancelable: true,
      view: window,
    }),
  );
}
